import { forwardRef, type Ref, type SVGProps } from "react";
const IconChevronRightOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M11.3 3.71 23.59 16 11.31 28.29a1 1 0 0 0 1.41 1.41l13-13a1 1 0 0 0 0-1.42l-13-13a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.43"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconChevronRightOutlineSVG);
ForwardRef.displayName = "IconChevronRightOutline";
export { ForwardRef as IconChevronRightOutline };
